/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Divider, Paper, Typography, FormControl, FormControlLabel, Checkbox, Select, MenuItem, Button } from '@material-ui/core'

import Action from '../../fluid/Actions/ActionFactory';

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class M2CDashboard extends React.Component {
    state = {
        loading : false,
        dashboard_data : null,
        period : 'Today',
        mailbox : null,
        destination_crm : null
    }
    
    componentDidMount () {
        this.setState({...this.state, loading : true}, () => {
            Action('http_request', {
                url : "/sainapse/configuration/dashboard_data",
                method : 'get',
                data : {}
            }).then(res => {
                this.setState({...this.state, loading : false, dashboard_data : res.data.result.config.dashboard_data})
            })
        })
    }

    getConfig = (key_path) => {
        let config

        key_path.map((key, i) => {
            if (i === 0) {
                config = this.state.dashboard_data.find(cfg => cfg.key === key)
            } else {
                if (config.val_key === 'data') {
                    config = config[config.val_key].find(data => data.key === key)
                }
            }
        })

        console.log("Dash Data :: Getting Config : ", config)
        return config
    }

    changePeriod = (event) => {
        this.setState({...this.state, period : event.target.name})
    }

    render() { 
        const {classes} = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'h6'>Dashboard</Typography>
                </Paper>
                {this.state.dashboard_data && 
                <div style = {{width : '100%', height : '90vh', display : 'flex', flexDirection : 'column', padding : '10px'}}>
                    <div style = {{width : '100%', padding : '10px', display : 'flex', flexDirection : 'row'}}>
                        <Paper style = {{width : '32%', margin : '10px', padding : '10px'}}>
                            <Typography variant = 'subtitle2' color = 'primary'>Customer</Typography>
                            <Divider/>
                            <div style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                <Typography variant = 'h6'>{this.getConfig(['customer_name']).value}</Typography>
                            </div>
                        </Paper>
                        <Paper style = {{width : '32%', margin : '10px', padding : '10px'}}>
                            <Typography variant = 'subtitle2' color = 'primary'>Business Function</Typography>
                            <Divider/>
                            <div style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                <Typography variant = 'h6'>{this.getConfig(['business_function']).value}</Typography>
                            </div>
                        </Paper>
                        <Paper style = {{width : '32%', margin : '10px', padding : '10px'}}>
                            <Typography variant = 'subtitle2' color = 'primary'>Geography</Typography>
                            <Divider/>
                            <div style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                <Typography variant = 'h6'>{this.getConfig(['geography']).value}</Typography>
                            </div>
                        </Paper>
                    </div>
                    <Divider/>
                    <div style = {{width : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1}} variant = "subtitle2" color = 'primary'>Select Report Period :</Typography>
                        <FormControlLabel
                            control={
                                <Checkbox
                                  checked={this.state.period === 'YTD'}
                                  onChange={this.changePeriod}
                                  name="YTD"
                                  color="primary"
                                />
                              }
                              label="YTD"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                  checked={this.state.period === 'MTD'}
                                  onChange={this.changePeriod}
                                  name="MTD"
                                  color="primary"
                                />
                              }
                              label="MTD"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                  checked={this.state.period === 'WTD'}
                                  onChange={this.changePeriod}
                                  name="WTD"
                                  color="primary"
                                />
                              }
                              label="WTD"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                  checked={this.state.period === 'Today'}
                                  onChange={this.changePeriod}
                                  name="Today"
                                  color="primary"
                                />
                              }
                              label="Today"
                        />
                    </div>
                    <Paper style = {{margintop: '10px', width : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <div style = {{flexGrow : 1, margin : '5px'}}>
                            <Typography variant = 'subtitle2' color = 'primary'>Select Mailbox</Typography>
                            <FormControl fullWidth variant = 'outlined'>
                                <Select
                                    value = {this.state.mailbox}
                                    onChange = {(event) => this.setState({...this.state, mailbox : event.target.value})}
                                >
                                    {this.getConfig(['mailbox']).options.map(mailbox => {
                                        return (
                                            <MenuItem value = {mailbox}>{mailbox}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                        <div style = {{flexGrow : 1, margin : '5px'}}>
                            <Typography variant = 'subtitle2' color = 'primary'>Select Destination CRM</Typography>
                            <FormControl fullWidth variant = 'outlined'>
                                <Select
                                    value = {this.state.destination_crm}
                                    onChange = {(event) => this.setState({...this.state, destination_crm : event.target.value})}
                                >
                                    {this.getConfig(['destination_crm']).options.map(mailbox => {
                                        return (
                                            <MenuItem value = {mailbox}>{mailbox}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                    </Paper>
                    <div style = {{width : '100%', height : '30vh', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                        <Paper style = {{flexGrow : 1, height : '100%', margin : '10px', padding : '10px'}}>
                            {this.state.mailbox && <Paper variant = 'outlined' style = {{marginTop: '10px', padding : '10px'}}>
                                <Typography variant = 'subtitle2' color ='primary'>Number of Emails Received</Typography>
                                <Typography variant = 'h6'>{this.getConfig(['number_emails_received', this.state.mailbox, this.state.period]).value}</Typography>
                            </Paper>}
                            {this.state.mailbox && this.state.destination_crm && <Paper variant = 'outlined' style = {{marginTop: '10px', padding : '10px'}}>
                                <Typography variant = 'subtitle2' color ='primary'>Number of Emails Converted to Case</Typography>
                                <Typography variant = 'h6'>{this.getConfig(['number_emails_to_ticket', this.state.destination_crm, this.state.period]).value}</Typography>
                            </Paper>}
                        </Paper>
                        <Paper style = {{flexGrow : 1, height : '100%', margin : '10px', padding : '10px'}}>
                            {this.state.mailbox && this.state.destination_crm && <Paper variant = 'outlined' style = {{marginTop: '10px', padding : '10px'}}>
                                <Typography variant = 'subtitle2' color ='primary'>Cases with Recommendations provided</Typography>
                                <Typography variant = 'h6'>{this.getConfig(['cases_recommendation', this.state.destination_crm, this.state.period]).value}</Typography>
                            </Paper>}
                        </Paper>
                    </div>
                    <div style = {{width : '100%', marginTop: '10px',padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                        {this.state.mailbox && this.state.destination_crm && <Button variant = 'contained' color = 'primary'>Generate Billing Report</Button>}
                    </div>
                </div>}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(M2CDashboard);